import { Navigate, Outlet, useParams } from 'react-router-dom'
import { useAppSelector } from '../../store/hooks'
import Loader from './Loader'

/**
 * Prevents requestor workflows from mounting without an authorized approver.
 * Returns pending profiles to a loading state and blocked profiles to the home
 * page, which owns the no-approver and profile-error banners.
 */
function RequestorApproverGuard(): JSX.Element {
  const { mode } = useParams<{ mode?: string }>()
  const isAdminMode = mode === 'admin'
  const profile = useAppSelector((state) =>
    isAdminMode ? state.manualTimeOffProfile : state.profile
  )
  const requestorHome = isAdminMode ? '/admin/requestor' : '/requestor'

  if (profile.loading || (!profile.initialized && !isAdminMode)) {
    return <Loader />
  }

  if (
    !profile.initialized ||
    profile.error ||
    profile.data?.roles?.hasAuthorizedApprover !== true
  ) {
    return <Navigate to={requestorHome} replace />
  }

  return <Outlet />
}

export default RequestorApproverGuard